import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import config from '../config';
import { replaceHtmlExtensionWithSlash } from './strings';

export const useGetLanguageFromCurrentPage = () => {
  const location = useLocation();

  const paths = replaceHtmlExtensionWithSlash(location.pathname).split('/');

  return useMemo(() => paths.find((path) => config.SUPPORTED_LANGUAGES.includes(path)), [paths]);
};
